import React, { useEffect } from "react";
import { Col } from "antd";
import { InputField } from "../../../../../atoms/FormElement";
import { UnitTypeFields } from "./UnitTypeFields";
import { InputNumberFieldV2 as InputNumberField } from "../../../../../atoms/FormElement/InputNumberField";

export default (props) => {
  const { control, errors, noEdit, colSpan, propertyRefNumber = null, setValue, watch } = props;

  const floorNumber = watch("floorNumber");
  const unitNumber = watch("unitNumber");
  const suiteSize = watch("suiteSize");
  const balconySize = watch("balconySize");

  useEffect(() => {
    if (propertyRefNumber && floorNumber && unitNumber) {
      const generatedCode = `${propertyRefNumber}-${floorNumber}-${unitNumber}`;
      setValue("unitCode", generatedCode);
    } else {
      setValue("unitCode", "");
    }
  }, [propertyRefNumber, floorNumber, unitNumber, setValue]);

  useEffect(() => {
    const suite = parseFloat(suiteSize) || 0;
    const balcony = parseFloat(balconySize) || 0;
    if ((suite && balcony) || balcony === 0) {
      const totalArea = suite + balcony;
      // Round to 3 decimal places
      const roundedArea = Math.round(totalArea * 1000) / 1000;
      setValue("areaSqft", roundedArea.toString());
    } else {
      setValue("areaSqft", "");
    }
  }, [suiteSize, balconySize, setValue]);

  return (
    <>
      <Col span={colSpan ? colSpan : 6}>
        <InputField
          isRequired={!noEdit}
          label="Floor Number"
          fieldname="floorNumber"
          control={control}
          classes={`${noEdit ? "noEditLabel" : ""}`}
          initValue=""
          iProps={{
            placeholder: "Floor Number",
            readOnly: noEdit,
            className: `${noEdit ? "noEdit" : ""}`,
          }}
          rules={{ required: "Enter Floor Number" }}
          validate={errors.floorNumber && "error"}
          validMessage={errors.floorNumber && errors.floorNumber.message}
        />
      </Col>
      <Col span={colSpan ? colSpan : 6}>
        <InputField
          isRequired={!noEdit}
          label="Unit Number"
          fieldname="unitNumber"
          control={control}
          classes={`${noEdit ? "noEditLabel" : ""}`}
          initValue=""
          iProps={{
            placeholder: "Enter Unit Number",
            readOnly: noEdit,
            className: `${noEdit ? "noEdit" : ""}`,
          }}
          rules={{ required: "Enter Unit Number" }}
          validate={errors.unitNumber && "error"}
          validMessage={errors.unitNumber && errors.unitNumber.message}
        />
      </Col>
      <Col span={colSpan ? colSpan : 6}>
        <InputField
          isRequired={!noEdit}
          label="Unit Code"
          fieldname="unitCode"
          control={control}
          classes={`${noEdit ? "noEditLabel" : ""}`}
          initValue=""
          iProps={{
            placeholder: "Prop Ref No - Fl No - Un No.",
            readOnly: true,
            className: `${noEdit ? "noEdit" : ""}`,
          }}
          rules={{ required: "Enter Floor and Unit Number" }}
          validate={errors.unitCode && "error"}
          validMessage={errors.unitCode && errors.unitCode.message}
          disabled={!floorNumber || !unitNumber}
        />
      </Col>

      <UnitTypeFields colSpan={colSpan} />

      <Col span={colSpan ? colSpan : 6}>
        <InputNumberField
          isRequired={!noEdit}
          label="Internal Area"
          fieldname="suiteSize"
          control={control}
          inputNumberProps={{
            placeholder: "Enter Internal Area",
            precision: 2,
          }}
          disabled={noEdit}
          rules={{
            required: "Enter Internal Area",
          }}
        />
      </Col>

      <Col span={colSpan ? colSpan : 6}>
        <InputNumberField
          isRequired={!noEdit}
          label="External Area"
          fieldname="balconySize"
          control={control}
          inputNumberProps={{
            placeholder: "Enter External Area",
            precision: 2,
          }}
          disabled={noEdit}
          rules={{
            required: "Enter External Area",
          }}
        />
      </Col>

      <Col span={colSpan ? colSpan : 6}>
        <InputNumberField
          isRequired={!noEdit}
          label="Area Sqft"
          fieldname="areaSqft"
          control={control}
          inputNumberProps={{
            placeholder: "Suit Size + Balcony Size",
            readOnly: true,
            precision: 2,
          }}
          rules={{
            required: "Enter Suit and Balcony Size",
          }}
        />
      </Col>

      <Col span={colSpan ? colSpan : 6}>
        <InputField
          isRequired={false}
          label="Unit Description"
          fieldname="unitDescription"
          control={control}
          classes={`${noEdit ? "noEditLabel" : ""}`}
          initValue=""
          iProps={{
            placeholder: "Enter Unit Description",
            readOnly: false,
            className: `${noEdit ? "noEdit" : ""}`,
          }}
        />
      </Col>
    </>
  );
};
